import { __assign } from "tslib";
import { RemoveScroll } from 'react-remove-scroll/UI';
export { AutoFocusInside, MoveFocusInside, InFocusGuard } from 'react-focus-lock/UI';
export var classNames = __assign({}, RemoveScroll.classNames);
